import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';

export interface SupprimerContributionInput { idContribution: string; }

export class SupprimerContributionUseCase {
  constructor(private readonly repository: IContributionProjetRepository) {}

  async execute(input: SupprimerContributionInput): Promise<void> {
    const response = await this.repository.supprimer(input.idContribution);
    if (!response.succes) throw new Error(response.message || 'Erreur lors de la suppression');
  }
}
